import { render, staticRenderFns } from "./addVehicleModal.vue?vue&type=template&id=60dba952&"
import script from "./addVehicleModal.vue?vue&type=script&lang=js&"
export * from "./addVehicleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports